module.exports = __webpack_public_path__ + "img/1 (56).0eb8bed6.png";